import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InsightFormInvitePartner from "../modals/InsightFormInvitePartner";
import { MODAL_TYPES } from "../utils/emitter";
import { ADULT_ALERT_WAS_SHOWN, NOTIFY_MODAL_TYPES } from "../utils/constants";
import BaseIcon from "./BaseIcon";
import AdultAlert from "../modals/AdultAlert";
import useBrowserStorage from "../hooks/useBrowserStorage";
import useModalActions from "../hooks/useModalActions";
import PartnerBoughtGameModal from "../modals/PartnerBoughtGameModal";
import PaymentSuccessModal from "../modals/PaymentSuccessModal";
import EmailCodeModal from "../modals/EmailCodeModal";
import LinkWasNotSentModal from "../modals/LinkWasNotSentModal";
import Demonstration from "./Demonstration";
import EndGameModal from "../modals/EndGameModal";
import AddMainScreenModal from "../modals/AddMainScreenModal";
import ShopModal from "../modals/ShopModal";
import CookieNotice from "./CookieNotice";
import Etap2SocketBridge from "./Etap2SocketBridge";
import BuyProductModal from "../modals/BuyProductModal";
import NotEnoughPointsModal from "../modals/NotEnoughPointsModal";
import PointsInstructionModal from "../modals/PointsInstructionModal";
import PointsCongratsModal from "../modals/PointsCongratsModal";
import BlankFormDetailsModal from "../modals/BlankFormDetailsModal";
import Extended57OfferModal from "../modals/Extended57OfferModal";
import PartnerUnlocked57Modal from "../modals/PartnerUnlocked57Modal";
import Extended57ContinueModal from "../modals/Extended57ContinueModal";
import Extended57WaitPartnerModal from "../modals/Extended57WaitPartnerModal";
import CreateTestInfoModal from "../modals/CreateTestInfoModal";
import PurchaseFailedModal from "../modals/PurchaseFailedModal";
import SeeFullTestModal from "../modals/SeeFullTestModal";

export default function RootModals() {
  const { t } = useTranslation();
  // const { getItem } = useBrowserStorage();
  // const { openModal } = useModalActions();
  //
  // useEffect(() => {
  //   const wasShown = getItem(ADULT_ALERT_WAS_SHOWN);
  //   if (!wasShown) {
  //     openModal(MODAL_TYPES.ADULT_ALERT);
  //   }
  // });

  return (
    <>
      <CookieNotice />
      <Demonstration />
      <ShopModal />
      <PartnerBoughtGameModal />
      <PaymentSuccessModal />
      <EmailCodeModal />
      {/* 10.10: было только в ЛК — с анкеты, игры и бургер-меню «партнёр ещё не
          присоединился» не открывалось, кнопки молчали */}
      <LinkWasNotSentModal />
      <AdultAlert />
      <AddMainScreenModal />
      <Etap2SocketBridge />
      <BuyProductModal />
      <NotEnoughPointsModal />
      <PointsInstructionModal />
      <PointsCongratsModal />
      <BlankFormDetailsModal />
      <Extended57OfferModal />
      <PartnerUnlocked57Modal />
      <Extended57ContinueModal />
      <Extended57WaitPartnerModal />
      <CreateTestInfoModal />
      <PurchaseFailedModal />
      <SeeFullTestModal />
      {/*<InsightFormInvitePartner*/}
      {/*  title={t("insight_questionnaire_form_page.invite_from_partner")}*/}
      {/*  modalType={MODAL_TYPES.SHOW_INSIGHT_FORM_INVITE}*/}
      {/*  typeNotify={NOTIFY_MODAL_TYPES.INVITE_PARTNER}*/}
      {/*/>*/}
      <InsightFormInvitePartner
        title={t("insight_form_page.notify_from_insight")}
        logoIcon={<BaseIcon name="circle_notify_warn" />}
        modalType={MODAL_TYPES.SHOW_INSIGHT_FORM_INVITE}
        typeNotify={NOTIFY_MODAL_TYPES.INVITE_PARTNER}
      />
      <InsightFormInvitePartner
        title={t("insight_form_page.notify_from_insight")}
        logoIcon={<BaseIcon name="circle_notify_warn" />}
        modalType={MODAL_TYPES.INSIGHT_FORM_CAN_WATCH_NOTIFY}
        typeNotify={NOTIFY_MODAL_TYPES.NOTIFY_PARTNER}
      />
      <EndGameModal
        title={t("end_game.modalTitle")}
        modalType={MODAL_TYPES.SHOW_END_GAME}
      />
    </>
  );
}
